module.exports = __webpack_public_path__ + "img/199.3719d706.jpg";